import { Button, TOUCH } from "@nymbl/nos2-rules";
import { TEAM_TAG_FILTER_OPTIONS, TEAM_TAG_FILTERS, type TeamTagFilter } from "@/lib/enums";
import { cn } from "@/lib/utils";

const TAGS = TEAM_TAG_FILTERS.map((tag) => ({
  tag,
  label: TEAM_TAG_FILTER_OPTIONS.find((o) => o.value === tag)?.label ?? tag,
}));

interface TagTogglesProps {
  value: TeamTagFilter;
  onChange: (tag: TeamTagFilter) => void;
}

/**
 * The My Team tag filter as the table's toggles (UI standard 10): one of Below target or
 * Under guidance, or neither (everyone). Pressing the pressed one turns it off.
 */
export function TagToggles({ value, onChange }: TagTogglesProps) {
  return (
    <fieldset className="m-0 flex min-w-0 gap-2 border-0 p-0" aria-label="Show only">
      {TAGS.map(({ tag, label }) => {
        const on = value === tag;
        return (
          <Button
            key={tag}
            type="button"
            variant={on ? "secondary" : "outline"}
            aria-pressed={on}
            className={cn(TOUCH, "whitespace-nowrap", on && "ring-1 ring-primary")}
            onClick={() => onChange(on ? "" : tag)}
          >
            {label}
          </Button>
        );
      })}
    </fieldset>
  );
}
